import { RetryPlugin } from "@module-federation/retry-plugin";

const retryPlugin = () =>
	RetryPlugin({
		fetch: {
			retryTimes: 0,
		},
		script: {
			retryTimes: 3,
			retryDelay: 1000,
		},
	});

export default retryPlugin;
